import {EntityStore, StoreConfig} from "@datorama/akita";
import {MatchResponse, MatchState} from "./models";
import {Player} from "../player/models";

function initialState() {
    return {
        ui: {
            matchBuilderPlayers: [],
            lastMatchResult: null
        }
    }
}

// TODO: put match entities on player ui
@StoreConfig({name: 'match', resettable: true})
export class MatchStore extends EntityStore<MatchState> {
    constructor() {
        super(initialState());
    }

    updateMatchBuilderPlayers(matchBuilderPlayers: Player[]) {
        this.update(state => ({ui: {...state.ui, matchBuilderPlayers}}))
    }

    setLastMatchResult(result: MatchResponse | null) {
        this.update(state => ({ui: {...state.ui, lastMatchResult: result}}))
    }
}